<template>
	<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 section-container">
		<h4 class="section-title">{{label}}</h4>
	</div>
</template>
<script>
	export default {
		props: {
			label: {}
		}
	}
</script>

<style scoped>
	.section-title {
		color: #FFF;
		padding: 8px;
		border-radius: 6px;
		background-color: #353690;
		font-weight: bold;
		font-size: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Review/Section.vue